module.exports = __webpack_public_path__ + "img/swans_Right.e5045c03.gif";